(function () {
  'use strict';
  var LS_KEY = 'mundi_wishlist';

  function getWL() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || '[]'); } catch (e) { return []; }
  }
  function setWL(list) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(list)); } catch (e) {}
    updateFavCount();
  }
  function inWL(handle) {
    return getWL().some(function (i) { return i.handle === handle; });
  }
  function updateFavCount() {
    var n = getWL().length;
    var el = document.getElementById('fav-count');
    if (el) { el.textContent = n; el.style.display = n ? 'flex' : 'none'; }
  }
  function toast(html) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.innerHTML = html;
    t.classList.add('show');
    clearTimeout(t._tm);
    t._tm = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---- wishlist hearts ---- */
  function paintHearts() {
    document.querySelectorAll('.js-fav').forEach(function (b) {
      b.classList.toggle('on', inWL(b.dataset.handle));
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.js-fav');
    if (!b) return;
    e.preventDefault();
    var list = getWL();
    if (inWL(b.dataset.handle)) {
      list = list.filter(function (i) { return i.handle !== b.dataset.handle; });
      setWL(list);
      toast((window.mundiI18n||{}).removed || 'Removed');
    } else {
      list.push({
        handle: b.dataset.handle, title: b.dataset.title,
        url: b.dataset.url, price: b.dataset.price, image: b.dataset.image
      });
      setWL(list);
      toast('<b>♥</b> ' + ((window.mundiI18n||{}).added || 'Added'));
    }
    paintHearts();
  });

  /* ---- a doua poză pe card, la trecerea cu mouse-ul ----
     Poza nu are src în HTML, doar data-src, deci până aici nu s-a descărcat
     nimic în plus. O punem la prima intrare a cursorului pe card și o arătăm
     abia după ce s-a încărcat, ca să nu clipească un dreptunghi gol.
     Pe telefon evenimentul practic nu apare, deci nu se descarcă nimic. */
  document.addEventListener('mouseover', function (e) {
    if (!e.target || !e.target.closest) return;
    var card = e.target.closest('.pc, .lgh-card');
    if (!card) return;
    var im = card.querySelector('img.ph2[data-src]');
    if (!im) return;
    var url = im.getAttribute('data-src');
    im.removeAttribute('data-src');
    if (!url) return;
    im.addEventListener('load', function () { im.classList.add('ready'); });
    im.src = url;
  });

  /* ---- wishlist drawer ---- */
  function renderDrawer() {
    var box = document.getElementById('favlist');
    if (!box) return;
    var list = getWL();
    if (!list.length) {
      box.innerHTML = '<div class="dempty">' + (((window.mundiI18n||{}).empty) || 'No favorites yet.') + '</div>';
      return;
    }
    box.innerHTML = list.map(function (i) {
      var img = i.image ? '<img src="' + i.image + '" alt="">' : '<svg width="30" height="30"><use href="#die"/></svg>';
      return '<div class="ditem"><a class="im" href="' + i.url + '">' + img + '</a>' +
        '<div><a class="tt" href="' + i.url + '">' + i.title + '</a><div class="pp2">' + (i.price || '') + '</div></div>' +
        '<button class="rm" data-h="' + i.handle + '" aria-label="Șterge">✕</button></div>';
    }).join('');
    box.querySelectorAll('.rm').forEach(function (r) {
      r.addEventListener('click', function () {
        setWL(getWL().filter(function (i) { return i.handle !== r.dataset.h; }));
        renderDrawer(); paintHearts();
      });
    });
  }
  function openDrawer() {
    renderDrawer();
    document.getElementById('favdrawer').classList.add('open');
    document.getElementById('favbg').classList.add('open');
  }
  function closeDrawer() {
    document.getElementById('favdrawer').classList.remove('open');
    document.getElementById('favbg').classList.remove('open');
  }
  document.addEventListener('DOMContentLoaded', function () {
    var open = document.getElementById('favopen');
    if (open) open.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    var c = document.getElementById('favclose'); if (c) c.addEventListener('click', closeDrawer);
    var bg = document.getElementById('favbg'); if (bg) bg.addEventListener('click', closeDrawer);
    updateFavCount(); paintHearts();

    /* hero slider */
    document.querySelectorAll('[data-hero]').forEach(function (hero) {
      var slides = hero.querySelectorAll('.slide');
      var dots = hero.querySelectorAll('.dots i');
      if (slides.length < 2) return;
      var cur = 0, tm;
      function show(n) {
        cur = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('on', i === cur); });
        dots.forEach(function (d, i) { d.classList.toggle('on', i === cur); });
      }
      function auto() { clearInterval(tm); tm = setInterval(function () { show(cur + 1); }, 5200); }
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { clearInterval(tm); show(i); auto(); });
      });

      /* ---- când pornește derularea automată -----------------------
         Nu la DOMContentLoaded, ci după ce pagina s-a încărcat de tot.

         Motivul e o poză. Slide-urile care nu-s pe ecran stau pe
         display:none, deci fundalul lor nici nu se cere — bine. Dar la
         prima schimbare, slide-ul 2 devine vizibil și abia atunci începe
         să-și descarce poza: 60 KB pe telefon. Pe 4G, unde toată pagina
         se așază în 5–10 secunde, cronometrul de 5,2 s cădea EXACT peste
         descărcarea pozei din slide-ul 1 — adică peste elementul LCP,
         singurul lucru pe care Google îl cronometrează aici. Două poze
         mari pe aceeași bandă îngustă înseamnă că amândouă vin mai
         târziu.

         `load` se produce oricum înainte ca cineva să apuce să se uite
         la al doilea slide, deci pentru om nu se schimbă nimic: tot la
         5,2 secunde de la prima poză vine a doua.

         visibilitychange: dacă tabul e în fundal, oprim. Altfel un tab
         uitat deschis schimba slide-uri ore în șir și descărca poze pe
         care nu le vedea nimeni. */
      function porneste() {
        if (document.hidden) return;
        auto();
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) clearInterval(tm);
        else if (document.readyState === 'complete') auto();
      });
      if (document.readyState === 'complete') porneste();
      else window.addEventListener('load', porneste);

      /* ---- glisare cu degetul ------------------------------------
         Pe telefon săgețile sunt ascunse, iar punctele au 8px: caruselul
         arăta ca o poză fixă care se schimbă singură. Aici îi dăm degetul.

         Douăzeci de linii, nu o bibliotecă de 25KB. Fără dependențe noi și
         fără nicio cerere în plus.

         Amândoi ascultătorii sunt PASIVI și nicăieri nu chemăm
         preventDefault: derularea verticală a paginii nu e blocată nici
         măcar o clipă, fiindcă browserul n-are de ce să aștepte răspunsul
         JS-ului ca să afle dacă mișcarea e a lui. O pagină care se agață la
         derulare e mai rea decât un carusel fără glisare.

         Decidem abia când degetul se ridică, comparând cele două axe: dacă
         mișcarea e mai mult verticală, omul derula pagina și nu ne atingem
         de slide.

         Pragul de 45px e peste „slop”-ul browserului (~10px), deci un
         tremur nu schimbă slide-ul — iar peste el browserul anulează singur
         click-ul, deci o glisare pornită de pe butonul din slide nu duce
         nicăieri din greșeală.

         Direcția e cea a unei file de hârtie: tragi spre stânga, vine
         următorul.

         Schimbarea trece prin punct, exact ca la săgeți: tot ce înseamnă
         „alt slide” intră prin aceeași ușă, deci cronometrul se oprește și
         repornește într-un singur loc, nu în trei.
         ---------------------------------------------------------- */
      var x0 = null, y0 = 0;
      hero.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { x0 = null; return; }
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
      }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0;
        var dy = t.clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
        dots[(cur + (dx < 0 ? 1 : -1) + dots.length) % dots.length].click();
      }, { passive: true });
    });

    /* sort select on collection */
    var sort = document.getElementById('sort-by');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      /* sortarea repune lista de la capăt: altfel alegi „preț crescător” și
         aterizezi în mijlocul rezultatelor, nu la cel mai ieftin */
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

  /* ---- ajax add to cart ---- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form.js-atc');
    if (!f) return;
    e.preventDefault();
    var fd = new FormData(f);
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', body: fd, headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('err');
      return r.json();
    }).then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      var c = document.getElementById('cart-count');
      if (c) { c.textContent = cart.item_count; c.style.display = cart.item_count ? 'flex' : 'none'; }
      toast('<b>✓</b> ' + ((window.mundiI18n||{}).addedCart || 'Added to cart'));
    }).catch(function () { f.submit(); });
  });
})();
